import { render, staticRenderFns } from "./TravelDetailNew.vue?vue&type=template&id=61220580&scoped=true&"
import script from "./TravelDetailNew.vue?vue&type=script&lang=js&"
export * from "./TravelDetailNew.vue?vue&type=script&lang=js&"
import style0 from "./TravelDetailNew.vue?vue&type=style&index=0&id=61220580&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61220580",
  null
  
)

export default component.exports